import styled from 'styled-components';
import { px2rem } from '@stylesheets/tools';

const StyledEducationRefinement = styled.div`
  .refinement__headline {
    margin-bottom: ${px2rem('10px')};
  }
  .refinement__grid {
    display: flex;
    flex-wrap: wrap;
    gap: ${px2rem('10px')};

    .filter-tag {
      padding: ${px2rem('4px')} ${px2rem('10px')};

      .filter-tag__title {
        font-size: ${px2rem('16px')};
      }
    }
  }
`;

export default StyledEducationRefinement;
